<template>
  <div>
    <div class="container-fluid login">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-10 col-sm-8 mx-auto login-form">
            <router-link to="/" class="content-logo-principal">
              <div>
                <h1>
                  <a href="https://royalpag.com">
                      <img :src="img" style="width: 250px">
                  </a>
                </h1>
              </div>
            </router-link>
            <div v-if="!solicitacaoEnviada">
              <h2 class="text-center text-default-gray logo_h2 pb-5" style="font-size: 16px; font-family: Roboto;">
                Não recebeu o e-mail de verificação?
              </h2>
              <div class="card-body pt-0">
                <div class="row">
                  <div class="col-12">
                    <form class="well top4" style="text-align-last: center;" @submit.prevent="solicitarNovoEmail">
                      <div class="row justify-content-center">
                        <b class="form-group justify-content-center">
                          <button type="submit" class="btn btn-primary btn-block mb-3 center-align" style="width: 200px;">
                            <i class="fa fa-envelope fa-2x float-left pr-2"></i>
                            <div  style="padding-left: 35px; position: absolute; padding-top: 3px;" class="text-center">Reenviar e-mail</div>
                          </button>
                        </b>
                      </div>
                      <span class="sign-in" style="color: gray;">Já é um membro?  <router-link to="/auth/login" style="padding-left:20px">Entrar</router-link></span>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <h2 class="text-center text-default-gray logo_h2 pb-5" style="font-size: 16px; font-family: Roboto;">
                E-mail enviado com sucesso!
              </h2>
              <p class="text-justify text-default-gray" style="font-size: 14px; font-family: Roboto;">Cofira sua caixa de e-mail. Não esqueça de verifcar a caixa de spam.</p>
              <div class="form-group">
                <input type="reset" @click.prevent="voltar" value="Voltar" class="btn btn-primary btn-block"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import http from '@/service/http'
  import localforage from 'localforage'
  import 'bootstrap-pincode-input/css/bootstrap-pincode-input.css'
  import 'bootstrap-pincode-input/js/bootstrap-pincode-input'
  import { mapActions } from 'vuex'
  import site_style from '@/service/site_style'
  export default {
    name: 'Token',
    computed: {
    },
    mounted () {
      if (window.location.href.indexOf('?') !== -1) {
        if (this.$route.query && this.$route.query.ieu) {
          this.usuario.codigoEmail = this.$route.query.ieu
          this.verificarCodigoEmail()
          // localforage.setItem('inviteId', this.$route.query.identificador)
          // this.saveRequest(this.$route.query.identificador, 'requisicao')
        }
      }
      // let self = this
    },
    data () {
      return {
        img: site_style.getLogo().default,        
        solicitacaoEnviada: false,
        usuario: {
          key: '',
          value: '',
          codigoSms: '',
          codigoEmail: '',
          emailVerificado: false,
          codigoSmsVerificado: false
        }
      }
    },
    methods: {
      ...mapActions('usuarios', ['solicitarNovoEmailVerificacao']),
      voltar () {
        this.$router.push({ name: 'auth.index' })
      },
      async solicitarNovoEmail () {
        let self = this
        this.usuario.key = 'I-INA-SYSTEM'
        let token = await localforage.getItem('I-INA-SYSTEM')
        this.usuario.value = token
        const verb = 'post'
        const { usuario } = this
        console.log(usuario)
        await this.solicitarNovoEmailVerificacao({ verb, usuario }).then((message) => {
          if (message) {
            self.usuario.codigoSmsVerificado = message.codigoSmsVerificado
            self.usuario.emailVerificado = message.emailVerificado
            self.solicitacaoEnviada = true
            console.log(message)
          }
        })
      }
    }
  }
</script>

<style src="../../assets/css/login.css" scoped></style>
<style scoped>
  .token {
    text-align: center;
  }
  .top25 {
    margin-top: 25px;
  }
  .login {
    padding-top: 6.5%;
    padding-bottom: 2%;
    width: 100%;
    height: 100vh;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    /*background: radial-gradient(ellipse at center, #5A93AF 0%, #004E74 100%);*/
    /*background: radial-gradient(ellipse at center, #63B9B4 0%, #008C83 100%);*/
    overflow-y: auto;
  }
  .submit-btn {
    background-color: rgba(255,255,255, .2);
  }
  .send-btn i {
    font-size: 25px;
    -webkit-transform: rotate(133deg);
    -moz-transform: rotate(133deg);
    -ms-transform: rotate(133deg);
    -o-transform: rotate(133deg);
    transform: rotate(133deg);
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// email.vue?d00e2f34